import { useEffect, useRef } from 'react'
import { useToast } from '@features/shared/components/Toast'
import type { MicrosoftConnectionStatus } from '../api/contracts'
import { useMicrosoftConnectionStatus } from '../hooks/useMicrosoftConnectionStatus'

/**
 * Says how a background Microsoft 365 setup ended, wherever the user is in
 * the app: it reads the connection only while it's connecting and toasts
 * when that changes. Mounted once, in the app shell.
 */
export function MicrosoftConnectionWatcher() {
  const { data } = useMicrosoftConnectionStatus({ onlyWhileConnecting: true })
  const { addToast } = useToast()
  const previous = useRef<MicrosoftConnectionStatus['setup_status'] | undefined>(undefined)

  useEffect(() => {
    const before = previous.current
    previous.current = data?.setup_status
    if (before !== 'connecting' || !data || data.setup_status === 'connecting') return
    if (data.setup_status === 'failed') {
      addToast({
        type: 'error',
        title: "Microsoft 365 couldn't connect",
        message: data.setup_error ?? undefined,
      })
    } else if (data.status === 'connected') {
      addToast({
        type: 'success',
        title: 'Microsoft 365 connected',
        message: 'Exchange mailbox permission checks are ready.',
      })
    }
  }, [data, addToast])

  return null
}
